import React from 'react'
import { Layout } from '../layouts/Layout';
import { MasukanTiket, RatingAplikasiHalaman } from '../componen/masukan/MasukanRating'

export const MasukanPages = () => (
  <Layout>
    <MasukanTiket />
  </Layout>
)

export const RatingAplikasiPages = () => (
  <Layout>
    <RatingAplikasiHalaman />
  </Layout>
)
